<template>
  <div class="floor-content news-common" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading">
    <div class="content-title">楼门牌</div>
    <div class="detail">
      <div class="sub-title">审批部门设置</div>
      <div class="cards">
        <el-card shadow="hover" v-for="(item,index) in floorList" :key="index">
          <el-popover placement="top" width="160" trigger="click" :ref="'popover-' + item.id">
            <p>删除后无法恢复！</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[`popover-` + item.id][0].doClose()"
              >取消</el-button>
              <el-button type="primary" size="mini" @click="delFloor(item)">确定</el-button>
            </div>
            <i slot="reference" class="el-icon-error"></i>
          </el-popover>
          <el-row>
            <el-col :span="11">
              <div>{{item.firstApproveDepartment[0]}}</div>
            </el-col>
            <el-col :span="13">
              <p>{{item.firstApproveDepartment}}</p>
              <span>{{item.createtime|moment("YYYY-MM-DD")}}</span>
            </el-col>
          </el-row>
        </el-card>
        <el-card shadow="hover" class="addCard">
          <div>
            <router-link
              :to="{ path: '/news/floorNum/add', query: { title:'楼门牌-审批部门',isSelect:true,level:floorList.length+1}}"
            >
              <i class="el-icon-circle-plus-outline"></i>
            </router-link>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/news/floorNum.js';
export default {
  data() {
    return {
      popoverVisible: false,
      floorList: [],
      loading: true
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let reqdata = {
        communityId: this.userInfo.communityId,
        communityType: this.userInfo.communityType,
        def2: 'building_house'
      };
      let res = await this.$http.get(`${api.floorList}`,{params:reqdata});
      if (res && res.isSucceed) {
        this.floorList = res.rows;
        this.loading = false;
      }
    },
    async delFloor(item) {
      this.$refs[`popover-` + item.id][0].doClose();
      this.loading = true;
      let res = await this.$http.get(`${api.delFloor}?id=${item.id}`);
      if (res && res.isSucceed) {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        // item.popoverVisible = false;
        this.getData();
      }
    }
  }
};
</script>
<style lang='less' scoped>
@import url('./newsCommon.less');
</style>
<style lang='less'>
@import url('./ele-newsCommon.less');
 .el-popover {
    p {
      margin: 10px !important;
    }

    .el-button {
      padding: 7px 10px;
    }
  }
</style>



